/* eslint-disable */
import { useParams } from "react-router-dom";
import settings from "../../../configs/settings";
import { useEffect, useState } from "react";
import {
  TextField,
  Box,
  Grid,
  Paper,
  Typography,
  Button,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getFactura, retryFacturaOdoo } from "../../../project/services/FacturaService";
import Message from "../../../project/utils/Message";
import { isEmptyObject } from "../../../project/utils/utils";
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import WaitingDialog from "../../utils/WaitingDialog";
//
// ################################################################################
//
const FacturaVer = () => {
  const params = useParams();
  const idFactura = params.idFactura;
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [factura, setFactura] = useState({});
  const [cobranzaGcClientes, setCobranzaGcClientes] = useState([]);
  const [facturaDetalle, setFacturaDetalle] = useState([]);
  const [clientes, setClientes] = useState("");
  const [facturaActualizadaEnOdoo, setFacturaActualizadaEnOdoo] = useState(false);

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion",
      headerName: "Descripción",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cantidad",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "precio_unitario",
      headerName: "Precio Unitario",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.precio_unitario.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "total",
      headerName: "Total",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = 0;
        if (factura.descripcion_corta_tipo_comprobante_fiscal == "factura-a") {
          _val = params.row.cantidad * (params.row.precio_unitario + params.row.iva);
        } else {
          _val = params.row.cantidad * params.row.precio_unitario;
        }
        return _val.toFixed(2);
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  const load = async () => {
    setIsDoingSomething(true);
    const response = await getFactura(idFactura);
    setIsDoingSomething(false);

    if (response.ok) {
      let _factura = response.data.data.factura;
      let _cobranzaGcClientes = response.data.data.cobranza_gc_clientes;
      let _facturaDetalle = response.data.data.factura_detalle;
      setFactura(_factura);
      setCobranzaGcClientes(_cobranzaGcClientes);
      setFacturaDetalle(_facturaDetalle);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    // obtengo los clientes de las gc cobradas

    let _clientes = "";
    cobranzaGcClientes.forEach((item) => {
      _clientes += item.nombre_cliente + " " + item.apellido_cliente + ", ";
    });
    _clientes = _clientes.slice(0, _clientes.length - 2);

    if (cobranzaGcClientes.length === 1) {
      _clientes = "Cliente de Gestión de Atención: " + _clientes;
    } else {
      _clientes = "Clientes de Gestión de Atención: " + _clientes;
    }
    setClientes(_clientes);
  }, [cobranzaGcClientes]);
  //
  // ################################################################################
  //
  useEffect(() => {
    // obtengo los clientes de las gc cobradas

    let _facturaActualizadaEnOdoo =
      factura.odoo_cliente_updated &&
      factura.odoo_cobranza_updated &&
      factura.odoo_comprobante_venta_updated;
    setFacturaActualizadaEnOdoo(_facturaActualizadaEnOdoo);
  }, [factura]);
  //
  // ################################################################################
  //
  const reintentarFacturaEnOdoo = () => {
    let _idComprobanteVenta = factura.id;

    const reintentar = async () => {
      setIsDoingSomething(true);
      const response = await retryFacturaOdoo(_idComprobanteVenta);
      setIsDoingSomething(false);

      if (!response.ok) {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };

    reintentar();
    load();
  };
  //
  // ################################################################################
  //
  const handleClose = () => {
    window.close();
  };
  //
  // ################################################################################
  //
  return (
    <>
      {!isEmptyObject(factura) && (
        <>
          <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
            <Paper elevation={1} >
              <Box sx={{ m: 1 }}>
                <Box sx={{ p: 1 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={12} lg={12}>
                      <Typography variant="h5" display="block" gutterBottom>
                        Factura {factura.numero_comprobante_venta}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={2} lg={2}>
                      <TextField
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "center" } }}
                        id="tipoComprobanteFiscal"
                        label="Tipo de comprobante"
                        variant="outlined"
                        size="small"
                        name="tipoComprobanteFiscal"
                        value={factura.descripcion_tipo_comprobante_fiscal}
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={2} lg={2}>
                      <TextField
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "center" } }}
                        id="numeroComprobanteVenta"
                        label="Número de Factura"
                        variant="outlined"
                        size="small"
                        name="numeroComprobanteVenta"
                        value={factura.numero_comprobante_venta}
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={2} lg={2}>
                      <TextField
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "center" } }}
                        id="fechaComprobanteVenta"
                        label="Fecha / hora de emisión"
                        variant="outlined"
                        size="small"
                        name="fechaComprobanteVenta"
                        value={factura.fecha_creacion}
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={2} lg={2}>
                      <TextField
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "center", textColor: "blue" } }}
                        id="facturaAnombreDe"
                        label="A nombre de"
                        variant="outlined"
                        size="small"
                        name="facturaAnombreDe"
                        value={
                          factura.nombre_cliente
                            ? factura.nombre_cliente + " " + factura.apellido_cliente
                            : factura.razon_social_persona_juridica
                        }
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={2} lg={2}>
                      <TextField
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "center" } }}
                        id="condicionFrenteIva"
                        label="Condición frente IVA"
                        variant="outlined"
                        size="small"
                        name="condicionFrenteIva"
                        value={factura.descripcion_condicion_frente_iva}
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={2} lg={2}>
                      <TextField
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "center" } }}
                        id="numeroDocumentoCuit"
                        label="Número de documento / CUIT"
                        variant="outlined"
                        size="small"
                        name="numeroDocumentoCuit"
                        value={
                          factura.numero_cuit_cuil_cliente
                            ? factura.numero_cuit_cuil_cliente
                            : factura.numero_cuit_persona_juridica
                        }
                        disabled
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={{ border: "1px solid LightGrey", m: 1, p: 1, borderRadius: "5px" }}>
                  <Typography component={"span"} variant={"body1"}>
                    Factura para Cobranza {factura.codigo_cobranza} del día{" "}
                    {factura.fecha_creacion_cobranza} hs
                  </Typography>
                  <Typography variant="h8" display="block" gutterBottom>
                    {clientes}
                  </Typography>
                </Box>

                <Box sx={{ border: "1px solid LightGrey", m: 1, p: 1, borderRadius: "5px" }}>
                  <DataGrid
                    rows={facturaDetalle}
                    columns={tableColumns}
                    {...tableOptions}
                  />
                </Box>

                {factura.cancelatoria && (
                  <Box sx={{ width: "100%", m: 1, mt: 2 }}>
                    <Grid container spacing={1}>
                      <Grid item xs={2} md={2} lg={2}>
                        <TextField
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" } }}
                          id="subTotalItems"
                          label="Subtotal"
                          variant="outlined"
                          size="small"
                          name="subTotalItems"
                          value={factura.subtotal0.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                          disabled
                        />
                      </Grid>

                      <Grid item xs={2} md={2} lg={2}>
                        <TextField
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" } }}
                          id="totalDescuentos"
                          label="Descuentos"
                          variant="outlined"
                          size="small"
                          name="totalDescuentos"
                          value={factura.descuento.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                          disabled
                        />
                      </Grid>

                      <Grid item xs={2} md={2} lg={2}>
                        <TextField
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" } }}
                          id="totalRecargos"
                          label="Recargos"
                          variant="outlined"
                          size="small"
                          name="totalRecargos"
                          value={factura.recargo.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={2} md={2} lg={2}>
                        <TextField
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" } }}
                          id="totalCobrosACuenta"
                          label="Pagos a Cuenta (incluye Obras Sociales)"
                          variant="outlined"
                          size="small"
                          name="totalCobrosACuenta"
                          value={factura.acuenta.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={2} md={2} lg={2}>
                        <TextField
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "center" } }}
                          id="totalNoFacturable"
                          label="Canjes y Descuentos especiales"
                          variant="outlined"
                          size="small"
                          name="totalNoFacturable"
                          value={factura.otros_no_facturables.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                          disabled
                        />
                      </Grid>
                    </Grid>
                  </Box>
                )}

                <Box sx={{ width: "100%", m: 1, mt: 2 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={2} md={2} lg={2}>
                      <TextField
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "center" } }}
                        id="subTotalFactura"
                        label="Subtotal"
                        variant="outlined"
                        size="small"
                        name="subTotalFactura"
                        value={factura.subtotal.toLocaleString(
                          settings.numericLocales.language,
                          settings.numericLocales.options
                        )}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <TextField
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "center" } }}
                        id="ivaFactura"
                        label="IVA"
                        variant="outlined"
                        size="small"
                        name="ivaFactura"
                        value={factura.iva.toLocaleString(
                          settings.numericLocales.language,
                          settings.numericLocales.options
                        )}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <TextField
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "center" } }}
                        id="totalFactura"
                        label="Total"
                        variant="outlined"
                        size="small"
                        name="totalFactura"
                        value={factura.total.toLocaleString(
                          settings.numericLocales.language,
                          settings.numericLocales.options
                        )}
                        disabled
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Paper>
            <Paper elevation={1} >
              <Box sx={{ mx: 1, px: 1, pb: 1 }}>
                <Grid container spacing={1}>
                  <>
                    {!facturaActualizadaEnOdoo && (
                      <Grid item xs={12} md={12} lg={12}>
                        <Typography variant="h5" display="block" gutterBottom>
                          La Factura de esta Cobranza no se encuentra totalmente actualizada en Odoo
                        </Typography>
                      </Grid>
                    )}
                    <Grid item xs={12} md={12} lg={12}>
                      {!facturaActualizadaEnOdoo && (
                        <Button
                          sx={{ mr: 1, width: "20%" }}
                          variant="outlined"
                          onClick={reintentarFacturaEnOdoo}
                          startIcon={<CompareArrowsOutlinedIcon />}
                        >
                          Actualizar en Odoo
                        </Button>
                      )}
                      <Button
                        sx={{ m: 1 }}
                        variant="outlined"
                        onClick={handleClose}
                        startIcon={<CancelIcon />}
                      >
                        Cerrar
                      </Button>
                    </Grid>
                  </>

                </Grid>
              </Box>
            </Paper>
          </Paper>
        </>
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default FacturaVer;
